export type CardCtaLinkProps = { label: string; bold?: boolean };

export function CardCtaLink({ label, bold = false }: CardCtaLinkProps) {
  return (
    <span
      className={`typography-text-small mt-auto inline-flex items-center gap-1 text-primary${bold ? ' font-semibold' : ''}`}
    >
      {label}
      <svg aria-hidden="true" className="size-3.5" viewBox="0 0 24 24">
        <path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
      </svg>
    </span>
  );
}
